import { render } from "./IndustrialBankApprovedDialog.vue?vue&type=template&id=85b66adc&scoped=true"
import script from "./IndustrialBankApprovedDialog.vue?vue&type=script&lang=ts"
export * from "./IndustrialBankApprovedDialog.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-85b66adc"

export default script